import { render, staticRenderFns } from "./InternationalTradingPage.vue?vue&type=template&id=5e611398&"
import script from "./InternationalTradingPage.vue?vue&type=script&lang=js&"
export * from "./InternationalTradingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports